<div class="dialog_main">
  <button class="dialog_close" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'Login' | translate }}</h2>
      <p>{{ 'LoginforExceptionalExperiences' | translate }}</p>
    </div>


    
    <form [formGroup]="loginFormGroup" (ngSubmit)="onSubmit()">
      <mat-tab-group
        class="site_tabs"
        [selectedIndex]="selectedTab"
        (selectedTabChange)="onTabChange($event)">
        <mat-tab [label]="'ContinueWithEmail' | translate">
          <div class="form_feilds">
            <div class="form_group">
              <mat-form-field appearance="fill">
                <input
                  matInput
                  [placeholder]="'EmailAddress' | translate"
                  class="form_control"
                  formControlName="email" />
                @if (submitted) {
                  @for (err of emailErrors; track $index) {
                    @if (loginFormGroup.controls['email'].hasError(err.key)) {
                      <mat-error>{{ err.message | translate }} </mat-error>
                    }
                  }
                }
              </mat-form-field>
            </div>

            <ng-container
              *ngTemplateOutlet="
                loginFields;
                context: { $implicit: 'password' }
              "></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="submitBtn"></ng-container>
        </mat-tab>

        <mat-tab [label]="'ContinueWithPhoneNumber' | translate">
          <div class="form_feilds">
            <div class="form_group">
              <ngx-mat-intl-tel-input
                [preferredCountries]="['ae', 'us']"
                [enablePlaceholder]="true"
                [enableSearch]="true"
                name="phone"
                describedBy="phoneInput"
                formControlName="phoneNo"
                class="phone_selector"
                maxlength="15"
                #phone
                (countryChanged)="
                  countryChangedEvent($event)
                "></ngx-mat-intl-tel-input>

              <div>
                @if (submitted) {
                  @if (
                    (loginFormGroup.get('phoneNo')?.value === '' ||
                      loginFormGroup.get('phoneNo')?.value === null) &&
                    loginFormGroup.get('phoneNo')?.hasError('required')
                  ) {
                    <mat-error
                      >{{ 'PhoneNumber' | translate }}
                      {{ 'isRequired' | translate }}</mat-error
                    >
                  }
                  @if (
                    loginFormGroup.get('phoneNo')?.value === undefined ||
                    loginFormGroup
                      .get('phoneNo')
                      ?.hasError('validatePhoneNumber')
                  ) {
                    <mat-error
                      >{{ 'PleaseEnterValid' | translate }}
                      {{ 'PhoneNumber' | translate }}
                    </mat-error>
                  }
                }
              </div>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="submitBtn"></ng-container>
        </mat-tab>
      </mat-tab-group>

      <div class="or">{{ 'Or' | translate }}</div>
      <div class="form_bottom">
        <div class="log_with">

          <div id="googleSignInDiv"></div>

          <div class="btn btn_primary br fb_sign" (click)="handleFacebookLogin()">
            <figure>
              <img src="{{ assetsConst.facebook_login_icon }}" alt="Icon" />
              <figcaption>Sign in</figcaption>
            </figure>
          </div>

        </div>
        <p>
          {{ 'DontHaveAccount' | translate }}
          <a [mat-dialog-close]="true" (click)="openSignupModal()">{{
            'SignUp' | translate
          }}</a>
        </p>
      </div>
    </form>
  </div>
</div>

<ng-template #loginFields let-controlName>
  <form [formGroup]="loginFormGroup">
    <div class="form_group">
      <mat-form-field>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          class="form_control"
          [placeholder]="'Password' | translate"
          [formControlName]="controlName" />
        <span
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-mat-label]="'Hide password'"
          [attr.aria-pressed]="hide"
          class="pass_icon">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </span>

        @if (submitted) {
          @if (loginFormGroup.get(controlName)?.hasError('required')) {
            <mat-error>
              {{ 'Password' | translate }} {{ 'isRequired' | translate }}
            </mat-error>
          }
        }
      </mat-form-field>
    </div>
  </form>
  <div class="form_group d_flex">
    <mat-checkbox
      [checked]="isRemembered"
      (change)="toggleRememberMe($event)"
      >{{ 'RememberMe' | translate }}</mat-checkbox
    >
    <a [mat-dialog-close]="true" (click)="openForgotPasswordModal()">{{
      'ForgotPassword' | translate
    }}</a>
  </div>
</ng-template>

<ng-template #submitBtn>
  <div class="form_btn">
    <button class="btn btn_primary" type="submit">
      {{ 'Continue' | translate }}
    </button>
  </div>
</ng-template>
